<template>
  <div id="app">
    <the-heading class="header"></the-heading>

    <main class="main__content">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import TheHeading from "./components/common.blocks/TheHeading.vue";

import { RU, RUS, EN, GBR } from "@/domain/locales.types";

export default {
  name: "app",
  components: {
    TheHeading
  },
  computed: {
    lang() {
      return this.$store.state.settings.lang;
    }
  },
  methods: {
    setInterfaceLang() {
      if (this.lang === RUS) {
        this.$i18n.locale = RU;
      } else if (this.lang === GBR) {
        this.$i18n.locale = EN;
      }
    }
  },
  mounted() {
    this.setInterfaceLang();
  },
  watch: {
    lang: function () {
      this.setInterfaceLang();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./css/variables.scss";

.header {
  height: 50px;
  margin-bottom: 10px;
}

.main__content {
  max-width: $content_weight;
  min-width: $content_weight;
  height: calc(100vh - 60px);
  margin: auto;
  background-color: $main_background_color;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
